import styles from './index.module.scss';
import ModuleRow from './module.row';
import { ModuleData } from './modules.mock-data';

interface ModulesTableProps {
  modules: ModuleData[];
  onModuleChange?: (moduleData: ModuleData) => void;
}

const ModulesTable = ({ modules, onModuleChange }: ModulesTableProps) => {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.headerColumn}>
          <h2 className={styles.title}>
            Modules
          </h2>
        </div>

        <div className={styles.headerColumnLimit}>
          <h2 className={styles.title}>
            Limit
          </h2>
        </div>
      </header>
      {modules.map((module, index) => (
        <ModuleRow
          key={`${module.label}-${index}`}
          label={module.label}
          unitLabel={module.unitLabel}
          isChecked={module.isChecked}
          userCount={module.userCount}
          limitType={module.limitType}
          onChange={onModuleChange ? (data) => {
            const updatedModule: ModuleData = {
              ...module,
              ...data,
            };
            onModuleChange(updatedModule);
          } : undefined}
        />
      ))}
    </div>
  );
};

export default ModulesTable;
